const accessKeysPT = {
    "view": {
        "title": "Chaves de acesso",
        "form": {
            "label": {
                "accessKeyId": "ID da Chave de Acesso",
                "secretAccessKey": "Chave de Acesso Secreta"
            },
            "button": {
                "hide": "Ocultar",
                "reveal": "Revelar"
            },
            "message": {
                "accessKeyIdCopied": "ID da Chave de Acesso copiado para a área de transferência!",
                "secretAccessKeyCopied": "Chave de Acesso Secreta copiada para a área de transferência!"
            }
        },
        "uploadInstructions": {
            "title": "Instruções",
            "step1": {
                "title": "Passo 1 - Baixar ferramenta de upload",
                "description": "Baixe a ferramenta <1>Cyberduck</1>."
            },
            "step2": {
                "title": "Passo 2 - Faça uma cópia da Planilha de Upload e salve o arquivo Trigger",
                "descriptionPoint1": "Copie esta <1><strong>PLANILHA</strong></1> para o seu GOOGLE DRIVE.",
                "descriptionPoint2": "Salve este <1><strong>ARQUIVO TRIGGER</strong></1> no seu computador ou armazenamento em nuvem."
            },
            "step3": {
                "title": "Passo 3 - Estabeleça a conexão",
                "descriptionPoint1": "Abra a ferramenta Cyberduck.",
                "descriptionPoint2": "No canto inferior esquerdo, clique no ícone +. (Adicionar novo marcador).",
                "descriptionPoint3": "Insira as seguintes credenciais:",
                "descriptionPoint4": "ID da Chave de Acesso: ",
                "descriptionPoint5": "Chave de Acesso Secreta: ",
                "descriptionPoint6": "Sua Pasta S3: ",
                "descriptionPoint7": "Seu Caminho S3 : ",
                "descriptionPoint8": "Siga estes passos:"
            },
            "step4": {
                "title": "Passo 4 - Preencha os metadados",
                "description": "Preencha os metadados de acordo com as instruções do nosso Centro de Ajuda."
            },
            "step5": {
                "title": "Passo 5 - Arquivos e Gêneros",
                "descriptionPoint1": "Faça o upload do seu arquivo <1>metadata.csv</1> e de todos os arquivos de áudio <3>(.wav)</3> e <5>imagem (.jpg)</5>, <7> NÃO (.jpeg)</7>",
                "descriptionPoint2": "Os arquivos <strong>JPG</strong> devem ser <strong>3000x3000 px, tamanho máximo de arquivo 4MB</strong>",
                "descriptionPoint3": "Os arquivos de áudio devem ser apenas <strong>wav, 16 bit, 44.1 khz</strong>",
                "descriptionPoint4": "Os nomes dos arquivos raiz devem ser uma única palavra",
                "descriptionPoint5": "<strong>IMPORTANTE:</strong> Esteja atento aos <2><strong>Gêneros de Dança ML</strong></2> e à correspondência nas lojas como Beatport."
            },
            "step6": {
                "title": "Passo 6 - Upload Trigger",
                "description": "Após todos os arquivos serem carregados, por favor, faça o upload deste arquivo trigger vazio <1>“last.zzz”</1>. Monitore seu e-mail para quaisquer notificações."
            },
            "step7": {
                "title": "Conselho - Teste conosco antes de fazer o upload",
                "description": "Sinta-se à vontade para entrar em contato com nossa equipe de suporte com quaisquer dúvidas sobre esta forma de criação de lançamento. Este é um processo muito simples que depende de tecnologias mais robustas, como AWS S3, e não depende de tecnologias de navegador. No entanto, requer que seus metadados sejam 100% precisos. A equipe Music Link pode testar o upload de alguns lançamentos para você com seus metadados para detectar possíveis problemas."
            }
        }
    }
};

export default accessKeysPT;